import React from 'react';

import MaterialCheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';

const StyledCheckbox = withStyles(theme => ({
  root: {
    color: '#A7A9BD'
  },
}))(MaterialCheckbox);

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: '12px',
    padding: '4px 8px',
    borderRadius: 8
  }
}));

const Checkbox = (props) => {
  const {
    input,
    color = 'primary',
    fontSize,
    label,
    disabled,
    fontWeight = 'bold',
    required,
  } = props;

  const classes = useStyles();

  return (
    <FormControlLabel
      style={{ marginRight: label ? 16 : 0 }}
      control={
        <StyledCheckbox
          { ...input }
          color={color}
          icon={<CheckBoxOutlineBlankIcon fontSize={fontSize} />}
          checkedIcon={<CheckBoxIcon fontSize={fontSize} />}
          disabled={disabled}
        />
      }
      label={
        required ? (
          <Tooltip
            title="Mandatory Equipment"
            aria-label="required-checkbox"
            classes={{ tooltip: classes.tooltip }}
          >
            <span
              className="checkbox-label-required"
              style={{
                fontWeight: fontWeight === 'regular' ? 'regular' : 'bold',
                color: required ? 'var(--app-text) !important' : 'inherit',
              }}>
             {`${label}*`}
            </span>
          </Tooltip>
        ) : (
          <span className="checkbox-label" style={{ fontWeight: fontWeight === 'regular' ? 'regular' : 'bold' }}>
            {label}
          </span>
        )
      }
    />
  );
};

export default Checkbox;
